import moment from 'moment';

export default function date (date) {
    let aux = moment(date, "YYYY-MM-DD");
    if(aux.isValid()){
        return aux.format("DD/MM/YYYY");
    }

    return date;
}